import {getInsurers, Insurer} from '../../const';

export const InsurerSelectionValueOptions = getInsurers();

export type InsurerSelectionValue = Insurer | null;
